<template>
  <div>
      <el-col :span="24" class="mb15">
      <el-button type="primary"  @click="back()" style="float: right; width: 110px">返回</el-button>
    </el-col >
    <el-card class="box-card mb15">
      <el-row :gutter="20">
        
        <el-col :xs="12" :sm="8" :md="8" :lg="5"
          ><el-input
            placeholder="请输入中文名称"
            v-model="listQuery.deName"
            clearable
          >
          </el-input
        ></el-col>
        <el-col :xs="12" :sm="8" :md="8" :lg="5"
          ><el-input
            placeholder="请输入值"
            v-model="listQuery.deCode"
            clearable
          >
          </el-input
        ></el-col>
        <el-col :xs="12" :sm="8" :md="8" :lg="5">
            <el-select
                v-model="listQuery.del"
                placeholder="请选择数据状态"
                clearable
                style="width: 100%"
            >
               <el-option  key="1"  label="可用"  value="1"> </el-option>
				<el-option  key="2"  label="不可用"  value="2"> </el-option>
            </el-select>
        </el-col>
        
        <el-col :xs="12" :sm="8" :md="8" :lg="7"
          ><el-button
            type="primary"
            icon="el-icon-search"
            style="float: left; width: 100px"
            @click="getList()"
            >搜索</el-button
          >
             <el-button
                    type="primary"
                    @click="addDeCode()"
                    style="float: left; width: 100px"
                    >新增</el-button >
          </el-col
        >
      </el-row>
    </el-card>

    <el-card class="box-card mb15">
        <el-table :data="tableData" style="width: 100%" stripe v-loading="loading">
            <el-table-column fixed prop="deName" label="中文名称">
            </el-table-column>
            <el-table-column prop="deValue" label="数值"> </el-table-column>
            <el-table-column prop="content" label="描述"> </el-table-column>
            <el-table-column prop="del" label="状态">
                <template slot-scope="scope">
                <el-tag :type="scope.row.del | blackDelStyleFilter">
                    {{ scope.row.del | blackDelNameFilter }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间"> </el-table-column>
            <el-table-column prop="updateTime" label="修改时间"> </el-table-column>
            <el-table-column label="操作">
                    <template slot-scope="{ row }">
                        <el-button-group>
                            
                            <el-button type="primary" size="mini"  @click="showEditDialog('edit', row)"
                                >编辑</el-button
                            >
                             <el-button type="danger" size="mini" @click="delDetail(row)"
                                    >删除</el-button
                                >
                        </el-button-group>
                    </template>
            </el-table-column>
        </el-table>

        <Pagination
            style="margin-top: 20px"
            v-show="parseInt(pageObj.count) > 0"
            :total="parseInt(pageObj.count)"
            @change="getList"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
        />
    </el-card>

        <el-dialog
            :title="addOrEdit?'数据字典详情-新增':'数据字典详情-编辑'"
            :visible.sync="dialogFormVisible"
            width="600px"
            @close="$reset('temp')"
            >
            <el-form ref="temp" :model="temp" :rules="rules" label-width="80px">
                <el-form-item label="中文名称" prop="deName">
                    <el-input v-model="temp.deName"></el-input>
                </el-form-item>
                <el-form-item label="数值" prop="deValue">
                    <el-input v-model="temp.deValue"></el-input>
                </el-form-item>
                <el-form-item label="描述" >
                    
                    <el-input
                        type="textarea"
                        v-model="temp.content"

                    ></el-input>
                </el-form-item>
                <el-form-item label="特殊资源" prop="del">
                    <el-radio-group v-model="temp.del">
                        <el-radio label="1" >可用</el-radio>
                        <el-radio label="2" >不可用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button v-show="!addOrEdit" type="primary" @click="handleAdd('temp')"
                >提 交</el-button
                >
                <el-button v-show="addOrEdit" type="primary" @click="handleAdd('temp')"
                >新 增</el-button
                >
            </div>
        </el-dialog>
  </div>
</template>

<script>
 
import { tbSysDictDetailQuery,tbSysDictDetailUpdate,tbSysDictDetailAdd,tbSysDictDetailDelete} from "@/api/system";
import { logLevelOptions } from "@/utils/selectData";
export default {
  created() {
    this.getList();
   
  },
  mounted() {
     
     
  },
  data() {
    return {
        temp: {},
        listQuery: {
            dictId:"",
            page: 1,
            limit: 10,
            deCode: "",
            deName: "",
            del: "",

        },
        tableData: [],
        pageObj: {},
        logLevelOptions,
        dataValue:"",
        loading:false,
        addOrEdit:true,
        dialogFormVisible:false,
        temp: {},
        rules: {
            deName: [
            { required: true, message: "请输入中文名称", trigger: "blur" },
                {
                    min: 1,
                    max: 15,
                    message: "长度在 1 到 15 个字符",
                    trigger: "blur",
                },
            ],
             deValue: [
            { required: true, message: "请输入值", trigger: "blur" },
                {
                    min: 1,
                    max: 15,
                    message: "长度在 1 到 15 个字符",
                    trigger: "blur",
                },
            ],

            del: [
                { required: true, message: '请选择是否可用', trigger: 'change' }
            ],
        },
    };
  },
    components: {
        
    },
    methods: {
    //获取列表
        getList() {
            this.listQuery.dictId=this.$route.query.id;
            this.loading=true;
            tbSysDictDetailQuery(this.listQuery).then((res) => {
                this.tableData = res.data.data;
                this.pageObj = res.data;
                this.loading=false;
            });
        },
        // 显示编辑弹出框
        showEditDialog(type, row) {
            if (type == "add") {
                this.addOrEdit = true;
            } else {
                this.addOrEdit = false;
            }
            this.temp = { ...row };
         
            this.dialogFormVisible = true;
        },
           //编辑
        handleAdd(temp) {
            this.$refs[temp].validate((valid) => {
                if (valid) {
                    if(this.addOrEdit){
                        this.temp.dictId=this.listQuery.dictId;
                        tbSysDictDetailAdd(this.temp).then((res) => {
                        
                        if(res.data.code == 0){
                            this.$message.success("保存成功");
                            this.dialogFormVisible = false;
                    
                            this.getList();
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    });
                    }else{
                        tbSysDictDetailUpdate(this.temp).then((res) => {
                    
                        if(res.data.code == 0){
                            this.$message.success("保存成功");
                            this.dialogFormVisible = false;
                    
                            this.getList();
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    });
                    }
                    
                }
            });
        },
        // 新增
        addDeCode(){
            this.temp.content="";
            this.dialogFormVisible = true;
        },
         //删除
        delDetail(row) {
            this.temp = { ...row };
            this.$confirm('确认删除？删除之后不再恢复！').then(_ => {
				var data={id: this.temp.id,deName: this.temp.name};

				tbSysDictDetailDelete(data).then(res =>{
					
					if(res.data.code == 0){
						this.$message.success(res.data.msg);
				
						this.getList();
					}else{
						this.$message.error(res.data.msg);
					}
				})

				
			})
			.catch(_ => {
			
			});
        },
          back(){//返回上一层
            this.$router.go(-1);
        },
     
    },
    filters: {

        typeFilter(data) {
            
        switch (data) {
            case "1":
            return "枚举";
            case "2":
            return "常量";
        
        }
        },
    },
};
</script>
